import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Home from "./views/Home";
import Buy from "./views/Buy";
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsConditions from "./views/TermsConditions";
import Join from "./views/Join";
import Search from "./views/Search";
import {wait} from '/src/util/helpers';
import store from '/src/store/index';
import OrderDetail from "./views/OrderDetail";
import {getAnalytics, logEvent} from "firebase/analytics";


Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "main",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/privacy_policy",
      name: "privacy_policy",
      components: {
        header: AppHeader,
        default: PrivacyPolicy,
        footer: AppFooter
      }
    },
    {
      path: "/terms_conditions",
      name: "terms_conditions",
      components: {
        header: AppHeader,
        default: TermsConditions,
        footer: AppFooter
      }
    },
    {
      path: "/buy",
      name: "buy",
      components: {
        header: AppHeader,
        default: Buy,
        footer: AppFooter
      }
    },
    {
      path: "/join",
      name: "join",
      components: {
        header: AppHeader,
        default: Join,
        footer: AppFooter
      }
    },
    {
      path: "/search",
      name: "search",
      components: {
        header: AppHeader,
        default: Search,
        footer: AppFooter
      }
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      components: {
        header: AppHeader,
        default: OrderDetail,
        footer: AppFooter
      },
      beforeEnter: (to, from, next) => {
        if (to.query.trade_no) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: "*",
      redirect: '/'
    },
    // {
    //   path: "/landing",
    //   name: "landing",
    //   components: {
    //     header: AppHeader,
    //     default: Landing,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // }
  ],
  // mode: 'history',
  scrollBehavior: to => {
    console.log('to', to);
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const targetId = to.hash.replace('#', '');
          const element = document.getElementById(targetId);
          console.log("element ", element);
          if (element) {
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 500); // 調整延遲時間以確保元素正確載入
        resolve();
      });
      // return { selector: to.hash };
    } else {
      return {x: 0, y: 0};
    }
  }
});

router.beforeEach(async (to, from, next) => {
  // console.log('from: ', from.path);
  // console.log('to: ', to.path);
  while (!store.state.isInit) {
    // console.log('\t|_ wait : ', store.state);
    await wait(100);
  }
  return next();
});


router.afterEach((to, from) => {
  const analytics = getAnalytics();
  logEvent(analytics, 'screen_view', {
    firebase_screen: to.name,
  });
});

export default router;
